<template>
  <nav class="nav">
    <div
        class="nav__item"
        v-for="item in list"
        @click="handleClick(item.id)"
        :class="{ 'active': activeItem === item.id }"
    >
      {{ t(item.text) }}
    </div>
  </nav>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import { computed } from 'vue';

const props = defineProps({
  list: Array,
  activeSection: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['navigate']);

const {t} = useI18n();

const activeItem = computed(() => props.activeSection);

const handleClick = (id) => {
  emit('navigate', id);
}
</script>

<style lang="scss" scoped>
.nav {
  width: fit-content;
  background-color: #F3FAFD;
  padding: 30px 38px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__item {
    width: 242px;
    cursor: pointer;
    padding-block: 10px;
    border-radius: 30px;
    border: 1px solid #5B194F;
    background-color: $white;
    transition: 0.2s;

    color: #2B3044;
    text-align: center;
    font-family: Syne, sans-serif;
    font-size: 16px;
    font-weight: 700;

    &:hover {
      background-color: #cccccc;
    }

    &.active {
      background-color: #2B3044;

      color: $white;
      font-size: 20px;
    }
  }
}

@media (max-width: 800px) {
  .nav {
    display: none;
  }
}
</style>